import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters('ucadm', ['getAttachmentModels', 'getAttachmentTypes']),
        //服务提供商
        getServiceProvider() {
            return [{
                trueValue: 0,
                label: '未定义',
            }, {
                trueValue: 1,
                label: '三方跳转',
            }, {
                trueValue: 2,
                label: '本地磁盘',
            }, {
                trueValue: 3,
                label: '阿里云OSS',
            }, {
                trueValue: 4,
                label: '亚马逊S3',
            }]
        },
        //环境类型
        getEnvTypes() {
            return [{
                value: 0,
                label: 'local',
            }, {
                value: 1,
                label: 'development',
            }, {
                value: 2,
                label: 'testing',
            }, {
                value: 3,
                label: 'staging',
            }, {
                value: 4,
                label: 'production',
            }]
        },
    },
}
